import React from "react";
import { useSettings } from "_contexts/useSettings";
import "./InputLabel.scss";

export default function InputLabel(oldProps) {
  const { settings } = useSettings();
  const props = { ...oldProps };
  props.className = "barn-label pp-input-label " + (props.className || "");

  if (props.started && !props.valid) {
    props.className += "pp-invalid";
  }

  return (
    <label {...props} style={{ color: settings?.secondary_color || "#000" }} />
  );
}
